/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    errorDialogTitle: {
        label: "Error"
    },
    errorDisplayCodeLabel: {
        label: "Error Code"
    },
    errorDisplayDebugLabel: {
        label: "Debug Informations"
    },
    errorDisplayMessageLabel: {
        label: "Error Message"
    },
    textCopied: {
        label: "Error copied to clipboard"
    }
};